<template>
  <div>
    <a v-if="mostrarPesquisa" @click="openNPS" class="btn-pesquisa-nps">
      Pesquisa Satisfação
      <span>
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' style="margin-top:10px;">
            <path d='M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5 9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75 7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25 7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125 17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z' fill='white' />
          </svg>
      </span>
    </a>
  </div>
</template>

<script>
// typeform import
import { createSlider } from '@typeform/embed';
import '@typeform/embed/build/css/slider.css';

export default { 
  name: 'TypeformNPS',
  data() {
    return {
      mostrarPesquisa: false,
      configsNPS: {
        meses: {
          dezembro: { mes: 11, diasPesquisa: 15, diaInicio: 5 },
        },
        mesNomenclatura: 12, // mes de nomenclatura para o nome campanha
        ano: 2023,
      }
    }
  },
  methods: {
    typeformID() {
      const isLocal = window.location.origin.includes('localhost');
      if (isLocal) {
        return 'VmiqwEew';
      } else {
        return process.env.NODE_ENV === 'development' ? 'VmiqwEew' : 'F1pF5fEJ';
      }
    },
    campanhaName() {
      const configsNPS = this.configsNPS;
      return `${configsNPS.mesNomenclatura.toString().length > 1 ? configsNPS.mesNomenclatura : '0' + configsNPS.mesNomenclatura}-${configsNPS.ano}-financas`
    },
    storageName() {
      return `f360.user.${this.typeformID()}.typeformModal.${this.campanhaName()}`
    },
    setStorage() {
      localStorage.setItem(this.storageName(), 'visualizado');
    },
    npsTesteDias(mes){
      const configsNPS = this.configsNPS;
      let callNPS = false
      for (let i = 0; i <= configsNPS.meses[mes].diasPesquisa; i++) {
        if (this.moment(new Date()).format('YYYY-MM-DD') ===  this.moment(new Date(configsNPS.ano, configsNPS.meses[mes].mes, configsNPS.meses[mes].diaInicio)).format('YYYY-MM-DD')) {
          callNPS = true;
        }
        configsNPS.meses[mes].diaInicio++
      }

      return callNPS
    },
    async getNPS(){
      const response = await this.axios.get(`${this.$urls.OBTER_USUARIO_NPS}?campanhaId=${this.typeformID()}&campanhaName=${this.campanhaName()}`);

      // caso o nps tenha sido respondido, ele não aparecerá mais
      if (response.data?.usuarioId) {
        this.mostrarPesquisa = false
      } else {
        this.mostrarPesquisa = true
      }

      const pesquisaVisualizada = localStorage.getItem(this.storageName())

      if (pesquisaVisualizada || this.mostrarPesquisa === false) {
        return
      }

      this.createAndOpenSlider('popup')
    },
    async postSaveNPS(valPost){
      const response = await this.axios.post(this.$urls.SALVAR_USUARIO_NPS, valPost);
        if(response.status === 200){
          this.mostrarPesquisa = false
        }
    },
    formatarProdutos(data) {
      const contabil = data?.TemContabil ? 'Contábil' : '';
      const emissor = data?.TemEmissorDeNotas ? 'Emissor' : '';
      const performance = data?.TemPerformance ? 'Performance' : '';
      const hasComma = (nome) => {
        return nome !== '' ? ', ' + nome : '';
      }

      return contabil + hasComma(emissor) + hasComma(performance);
    },
    createAndOpenSlider(origem){
      const getUserPromise = Promise.resolve(JSON.parse(localStorage.getItem('user')))
      const _this = this

      getUserPromise.then((userData) => {
        const slider = createSlider(_this.typeformID(), {
          open: 'load',
          hidden: {
            nome: userData?.user?.nome,
            email: userData?.user?.email,
            grupo: '-',
            codigoCliente: userData?.customer?.codigo,
            marcas: userData?.customer?.marcas?.map(marca => marca.label).join(','),
            qtdEmpresa: userData?.customer?.qtdeEmpresas,
            perfilAdm: userData?.user?.isAdmin,
            produtos: 'Painel',
            franqueadores: userData?.customer?.nome,
            mes: _this.moment((_this.configsNPS.mesNomenclatura + 1).toString()).format("MMMM"),
            origemClick: origem,
            ambiente: window.location.origin.includes('localhost') ? 'debug' : 'release',
            campanhaName: _this.campanhaName(),
            tempouso: '-'
          },
          onSubmit: function(event) {
            const valPost = {
              campanhaId: _this.typeformID(),
              campanhaName: _this.campanhaName(),
              respostaId: event.responseId,
              origemClick: origem
            };

            _this.postSaveNPS(valPost)
          }
        })

        slider.open()
        this.setStorage()
      })
    },
    openNPS() {
      this.createAndOpenSlider('Botão')
    }
  },  
  mounted() {
    const pesquisaVisualizada = localStorage.getItem(this.storageName())

    if (this.npsTesteDias('dezembro')) { // verifica dias permitidos para liberar nps
      this.getNPS()
    } else {
      this.mostrarPesquisa = false
    }
  }
}
</script>
<style lang="scss">
  .btn-pesquisa-nps {
    position: fixed;
    bottom: 15px;
    left: 17px;
    width: 190px;
    height: 35px;
    font-weight: 800;
    color: #fff;
    background: #ff3032;
    z-index: 9999;
    padding: 4px 9px;
    border-radius: 4px;
    cursor:pointer;
    text-decoration: none;
    transition:0.3s;
    span {
      position: absolute;
      top: -3px;
      right: 11px;
    }
    &:hover {
      background:#577c9e;
      color:#fff;
      text-decoration: none;
    }
  }
</style>